export default __webpack_public_path__ + "static/media/phone-web.ec770676.svg";